import React, { useState } from "react";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { OptimizeImage } from "../../../shared/utils/stringUtilities";
import { useStaticQuery, graphql } from "gatsby";
import AudioPlayer from 'react-h5-audio-player';
import { INLINES } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { wordFixerForGTM } from "../../../shared/utils/stringUtilities"
// import contentfulRenderOptions from "../../../utils/contentfulRenderOption";

// Compontents //
import Breadcrumb from '../../atoms/breadcrumb/breadcrumb';

// Helpers //
import { formatDate } from "../../../utils/helpers";

// Styles //
import "./headboardBibliotecas.scss";

const HeadboardBibliotecas = (props: ReferenciaCabecera) => {
    const icons = useStaticQuery(graphql`
        query ICONSBIBLIOTECAS {
            iconWebinar: allContentfulAsset(
                filter: { title: { eq: "icon-webinar" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconPodcast: allContentfulAsset(
                filter: { title: { eq: "icon-podcast" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconArticulo: allContentfulAsset(
                filter: { title: { eq: "icon-articulo" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconHistorias: allContentfulAsset(
                filter: { title: { eq: "icon-historias" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconLike: allContentfulAsset(
                filter: { title: { eq: "icon-like" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconService: allContentfulAsset(
                filter: { title: { eq: "icon-servicios" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconProject: allContentfulAsset(
                filter: { title: { eq: "icon-service" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconTime: allContentfulAsset(
                filter: { title: { eq: "icon-time" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
        }
    `);

    const { referenciaContenido } = props;
    const isBrowser = typeof window !== "undefined";
    const pathName = isBrowser ? window.location.pathname: '';


    const iconTime: string = icons.iconTime.nodes[0].file.url;
    const iconsCategoria: {[key: string]: string} = {
        "Artículo": icons.iconArticulo.nodes[0].file.url,
        "Podcast": icons.iconPodcast.nodes[0].file.url,
        "Webinar": icons.iconWebinar.nodes[0].file.url,
        "Historias que conectan": icons.iconHistorias.nodes[0].file.url,
        "Servicio de Empleo": icons.iconService.nodes[0].file.url,
        "Proyecto": icons.iconProject.nodes[0].file.url
    }

    const { referenciaMultimedia: refMultimedia } = props;
    const [showProtect, setShowProtect] = useState(true);

    const contentfulRenderOptions = {
        renderNode: {
            [INLINES.HYPERLINK]: ({ data }, children) => (
                <a
                    style={{ color: "var(--color-magenta-white)" }}
                    href={data.uri}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                    className={gtmBasedOnPathNameBanner()}
                >
                    {children}
                </a>
            ),
        },
        renderText: (text) =>
            text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
    };

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }
    
    const tituloMultimediaFixed = removeAccents(refMultimedia.tituloMultimedia).replace(/\s+/g, "").toLowerCase();

    const gtmBasedOnPathName = () =>{
        return `/${pathName.split('/')[2]}/${pathName.split('/')[3]}/` == `/${pathName.split('/')[2]}/biblioteca/` ?
            `gtm_reproducir_interna_${pathName.split('/')[2]}_${tituloMultimediaFixed}`
            :'';
    }

    const gtmBasedOnPathNameBanner = () => {
        return `gtm_aquiampliarinfo_${wordFixerForGTM(refMultimedia.tituloMultimedia)}_${pathName.split('/')[1]}_${wordFixerForGTM(refMultimedia?.categoriaMultimedia)}`
    }

    const handlePopup = () => {
        setShowProtect(false);
        sessionStorage.setItem("popup", "off");
    };

    return (
        <div className="o-bibliotecas-headboard">
            <div className="container">
                {referenciaContenido && (
                    <>
                        {refMultimedia?.categoriaMultimedia == "Proyecto" || refMultimedia?.categoriaMultimedia == "Servicio de Empleo" ? (   
                            <div
                                className={`banner-headboard-text__logo ${refMultimedia?.categoriaMultimedia == "Proyecto" ? 
                                    "banner-headboard-text__logo--bgcolorProyectos" : "banner-headboard-text__logo--bgcolorServicios"}`}
                                style={{ display: `${showProtect ? "flex" : "none"}` }}
                            >
                                <span onClick={handlePopup}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="17.536"
                                        height="17.536"
                                        viewBox="0 0 17.536 17.536"
                                    >
                                        <g id="x" transform="translate(1.768 1.768)">
                                            <line
                                                id="Línea_80"
                                                data-name="Línea 80"
                                                x1="14"
                                                y2="14"
                                                transform="translate(0 0)"
                                                fill="none"
                                                stroke="#303030"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2.5"
                                            />
                                            <line
                                                id="Línea_81"
                                                data-name="Línea 81"
                                                x2="14"
                                                y2="14"
                                                transform="translate(0 0)"
                                                fill="none"
                                                stroke="#303030"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2.5"
                                            />
                                        </g>
                                    </svg>
                                </span>
                                <div className="headboard-banner-image">
                                    <img src={referenciaContenido.imagenPrincipal[0].fields.file.url} alt={referenciaContenido.tituloBanner}/>
                                </div>
                                <div className="headboard-bibliotecas-text__header__title">
                                    <h3>{referenciaContenido.tituloBanner}</h3>
                                    <div className="headboard-bibliotecas-text__description">
                                        {documentToReactComponents(referenciaContenido.descripcion, contentfulRenderOptions)}
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </>
                )}
                <Breadcrumb content={props.migaDePan} />
                <div className="o-bibliotecas-headboard__container">
                    <div className="o-bibliotecas-headboard__container__main">
                        {refMultimedia?.categoriaMultimedia == "Artículo" || refMultimedia?.categoriaMultimedia == "Servicio de Empleo" || refMultimedia?.categoriaMultimedia == "Proyecto" ? (
                            <>
                                {refMultimedia.imagenPrincipal && (
                                    <div className="o-bibliotecas-headboard__cover">
                                        <img src={OptimizeImage(
                                                refMultimedia.imagenPrincipal.fields.file.url,
                                                refMultimedia.imagenPrincipal.fields.file.contentType,
                                                550
                                            )}
                                            alt={
                                                (refMultimedia.imagenPrincipal &&
                                                    refMultimedia.imagenPrincipal.title) ||
                                                "imagen cabecera"
                                            }
                                            loading="lazy"
                                        />
                                    </div>
                                )}
                                <div className="o-bibliotecas-headboard__intro">
                                    <div className="o-bibliotecas-headboard__intro__type">
                                        <img src={iconsCategoria[refMultimedia.categoriaMultimedia]} alt={refMultimedia.categoriaMultimedia} />
                                        {refMultimedia.categoriaMultimedia}
                                    </div>
                                    <h1 className="o-bibliotecas-headboard__intro__title">
                                        {refMultimedia.tituloMultimedia}
                                    </h1>
                                    {refMultimedia.imagenPrincipal && (
                                        <div className="o-bibliotecas-headboard__intro__cover">
                                            <img src={OptimizeImage(
                                                    refMultimedia.imagenPrincipal.fields.file.url,
                                                    refMultimedia.imagenPrincipal.fields.file.contentType,
                                                    550
                                                )}
                                                alt={
                                                    (refMultimedia.imagenPrincipal &&
                                                        refMultimedia.imagenPrincipal.title) ||
                                                    "imagen cabecera"
                                                }
                                                loading="lazy"
                                            />
                                        </div>
                                    )}
                                    <span className="o-bibliotecas-headboard__intro__span">
                                        {refMultimedia.tematica}
                                    </span>
                                    <div className="o-bibliotecas-headboard__intro__text">
                                        {refMultimedia.textoIntroductorio}
                                    </div>
                                    <div className="box-article">
                                        <span className="o-bibliotecas-headboard__intro__date">
                                            {formatDate(refMultimedia.createdAt)}
                                        </span>
                                        <span className="o-bibliotecas-headboard__intro__readingtime">
                                            <img src={iconTime} ></img>
                                            {`Te demoras ${refMultimedia.tiempoLectura} leyendo este artículo`}
                                        </span>
                                    </div>
                                </div>
                            </>
                        ) : null}
                        {refMultimedia?.categoriaMultimedia == "Webinar" || refMultimedia?.categoriaMultimedia == "Historias que conectan" ? (
                            <>
                                <div className={`o-bibliotecas-headboard__video ${gtmBasedOnPathName()}`}>
                                    {refMultimedia.video?.fields.file.url ? (
                                        <video controls poster={refMultimedia.imagenPrincipal.fields.file.url}>
                                            <source src={refMultimedia.video?.fields.file.url} type={refMultimedia.video?.fields.file.contentType} />
                                        </video>
                                    ) : (
                                        <iframe
                                            src={refMultimedia.videoUrl}
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                                        </iframe>                            
                                    )}
                                </div>
                                <div className="o-bibliotecas-headboard__intro webinar">
                                    <div className="box">
                                        <div className="o-bibliotecas-headboard__intro__type">
                                            <img src={iconsCategoria[refMultimedia.categoriaMultimedia]} alt={refMultimedia.categoriaMultimedia} />
                                            {refMultimedia.categoriaMultimedia}
                                        </div>
                                        <span className="o-bibliotecas-headboard__intro__date">
                                            {formatDate(refMultimedia.createdAt)}
                                        </span>
                                    </div>
                                    <h1 className="o-bibliotecas-headboard__intro__title">
                                        {refMultimedia.tituloMultimedia}
                                    </h1>
                                    <div className={`o-bibliotecas-headboard__video mobile ${gtmBasedOnPathName()}`}>
                                        {refMultimedia.video?.fields.file.url ? (
                                            <video controls poster={refMultimedia.imagenPrincipal.fields.file.url}>
                                                <source src={refMultimedia.video?.fields.file.url} type={refMultimedia.video?.fields.file.contentType} />
                                            </video>
                                        ) : (
                                            <iframe
                                                src={refMultimedia.videoUrl}
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                                            </iframe>                            
                                        )}
                                    </div>
                                    <span className="o-bibliotecas-headboard__intro__span">
                                        {refMultimedia.tematica}
                                    </span>
                                    <div className="o-bibliotecas-headboard__intro__text">
                                        {refMultimedia.textoIntroductorio}
                                    </div>
                                    <span className="mobile-date">
                                        {formatDate(refMultimedia.createdAt)}
                                    </span>
                                </div>
                            </>
                        ): null}
                        {refMultimedia?.categoriaMultimedia == "Podcast" && (
                            <>
                                <div className="o-multimedia-media-player">
                                    <div className="o-multimedia-media-player__content">
                                        {refMultimedia.imagenPrincipal && 
                                            <img src={refMultimedia.imagenPrincipal.fields.file.url}/>
                                        }
                                        <div className="o-multimedia-media-player__content__text">
                                            <h2>{refMultimedia.tituloMultimedia}</h2>
                                            <p>{`Autor: ${refMultimedia.autor}`}</p>
                                        </div>
                                    </div>
                                    {refMultimedia.audio.fields.file.url ? (
                                        <AudioPlayer 
                                            src={refMultimedia.audio.fields.file.url}
                                            layout="horizontal-reverse"
                                            className={`media-player ${gtmBasedOnPathName()}`}
                                            showJumpControls={false}
                                            showSkipControls={false}
                                        />
                                    ) : (
                                        <AudioPlayer 
                                            src={refMultimedia.audioUrl}
                                            layout="horizontal-reverse"
                                            className={`media-player ${gtmBasedOnPathName()}`}
                                            showJumpControls={false}
                                            showSkipControls={false}
                                        />
                                    )}
                                </div>
                                <div className="o-bibliotecas-headboard__intro">
                                    <div className="box">
                                        <div className="o-bibliotecas-headboard__intro__type">
                                            <img src={iconsCategoria[refMultimedia.categoriaMultimedia]} alt={refMultimedia.categoriaMultimedia} />
                                            {refMultimedia.categoriaMultimedia}
                                        </div>
                                        <span className="o-bibliotecas-headboard__intro__date">
                                            {formatDate(refMultimedia.createdAt)}
                                        </span>
                                    </div>
                                    <h1 className="o-bibliotecas-headboard__intro__title">
                                        {refMultimedia.tituloMultimedia}
                                    </h1>
                                    <div className="o-multimedia-media-player mobile">
                                        <div className="o-multimedia-media-player__content">
                                            {refMultimedia.imagenPrincipal && 
                                                <img src={refMultimedia.imagenPrincipal.fields.file.url}/>
                                            }
                                            <div className="o-multimedia-media-player__content__text">
                                                <h2>{refMultimedia.tituloMultimedia}</h2>
                                                <p>{`Autor: ${refMultimedia.autor}`}</p>
                                            </div>
                                        </div>
                                        {refMultimedia.audio.fields.file.url ? (
                                            <AudioPlayer 
                                                src={refMultimedia.audio.fields.file.url}
                                                layout="horizontal-reverse"
                                                className={`media-player ${gtmBasedOnPathName()}`}
                                                showJumpControls={false}
                                                showSkipControls={false}
                                            />
                                        ) : (
                                            <AudioPlayer 
                                                src={refMultimedia.audioUrl}
                                                layout="horizontal-reverse"
                                                className={`media-player ${gtmBasedOnPathName()}`}
                                                showJumpControls={false}
                                                showSkipControls={false}
                                            />
                                        )}
                                    </div>
                                    <span className="o-bibliotecas-headboard__intro__span">
                                        {refMultimedia.tematica}
                                    </span>
                                    <div className="o-bibliotecas-headboard__intro__text">
                                        {refMultimedia.textoIntroductorio}
                                    </div>
                                    <span className="mobile-date">
                                        {formatDate(refMultimedia.createdAt)}
                                    </span>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="o-bibliotecas-headboard__container__interests"></div>
                </div>
            </div>
        </div>
    );
};

export default HeadboardBibliotecas;
